const NO_GOOGLE_ANALYTICS_OBJECT = 'A google analytics object does not exist';
const NO_FUNNEL_ANALYTICS_OBJECT = 'A funnel analytics object does not exist';

export { NO_GOOGLE_ANALYTICS_OBJECT, NO_FUNNEL_ANALYTICS_OBJECT };
